import envcompany from 'envcompany';

export const routerConfig = {
    '/login': {
        title: `Login-${envcompany.baseName}`
    },
    '/reset-password': {
        title: `Reset Password-${envcompany.baseName}`
    },
    '/forget-password': {
        title: `Find Password-${envcompany.baseName}`
    },
    '/pages/password/update': {
        title: 'Change Password'
    },
    '/pages/app/appkey': {
        title: 'AppKey'
    },
    '/pages/app/appkey/view/:id': {
        title: 'Appkey Check',
        breadcrumb: [
            ['AppKey', '/pages/app/appkey'],
            ['Appkey Check']
        ]
    },
    '/pages/app/bundle': {
        title: 'Mobile Client'
    },
    '/pages/consumption': {
        title: 'Face Verification',
        breadcrumb: [
            ['Face Verification'],
        ]
    },
    '/pages/ktp-consumption': {
        title: 'Indonesia ID card',
        breadcrumb: [
            ['Indonesia ID card'],
        ]
    },'/pages/app/bundle/new':{
        title: 'Mobile Client',
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/app/bundle/:id':{
        title: 'Mobile Client',
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/app/bundle/:id/edit':{
        title: 'Mobile Client',
        breadcrumb: [
            ['Mobile Client'],
        ]
    },'/pages/sdk-download':{
        title: 'SDK DOWNLOAD',
        breadcrumb: [
            ['SDK Download'],
        ]
    },'/pages/sdk-scenes':{
        title: 'SDK Config Scenes',
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/sdk-scenes/create':{
        title: 'SDK Config Scenes',
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/sdk-scenes/edit/:id':{
        title: 'SDK Config Scenes',
        breadcrumb: [
            ['SDK Config Scenes'],
        ]
    },'/pages/verify-scenes':{
        title: 'Verify Config Scenes',
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/verify-scenes/create':{
        title: 'Verify Config Scenes',
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/verify-scenes/edit/:id':{
        title: 'Verify Config Scenes',
        breadcrumb: [
            ['Verify Config Scenes'],
        ]
    },'/pages/encryption':{
        title: 'Encryption',
        breadcrumb: [
            ['Encryption'],
        ]
    },'/pages/lite-scenes':{
        title: 'H5 Config Scenes',
        breadcrumb: [
            ['H5 Config Scenes'],
        ]
    },'/pages/lite-scenes/create':{
        title: 'H5 Config Scenes',
        breadcrumb: [
            ['H5 Config Scenes'],
        ]
    },'/pages/lite-scenes/edit/:id':{
        title: 'H5 Config Scenes',
        breadcrumb: [
            ['H5 Config Scenes'],
        ]
    }

};



// WEBPACK FOOTER //
// ./src/utils/routerConfig.js